import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface User {
	id: string;
	emailAddress: string;
	phoneNumber: string;
	firstName: string;
	lastName: string;
	isActive: boolean;
	isVerified: boolean;
	role: string;
	createdAt: string;
	updatedAt: string;
	signature?: string;
	isSignatureSet?: boolean;
}

interface UserState {
	user: User | null;
	token: string | null;
	isAuthenticated: boolean;
	expireTimer: string | number;
	resetToken: string | null;
}

const initialState: UserState = {
	user: null,
	token: null,
	isAuthenticated: false,
	expireTimer: "",
	resetToken: null,
};

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<{ user: User; token: string }>) => {
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.isAuthenticated = true;
		},
		clearUser: state => {
			state.user = null;
			state.token = null;
			state.isAuthenticated = false;
		},
		setExpireTimer: (state, action: PayloadAction<string>) => {
			state.expireTimer = action.payload;
		},
		setResetToken: (state, action: PayloadAction<string>) => {
			state.resetToken = action.payload;
		},
		initializeUser: (state, action: PayloadAction<{ user: User | null; token: string | null }>) => {
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.isAuthenticated = !!action.payload.token;
		},
	},
});

export const { setUser, clearUser, setExpireTimer, setResetToken, initializeUser } = userSlice.actions;
export default userSlice.reducer;
